import { Action } from 'redux';

export const SHOW_DATA_IMPORT_MODAL = 'data-import/SHOW_DATA_IMPORT_MODAL';
export const HIDE_DATA_IMPORT_MODAL = 'data-import/HIDE_DATA_IMPORT_MODAL';
export const SHOW_DATA_IMPORT_PROCESS_MODAL = 'data-import/SHOW_DATA_IMPORT_PROCESS_MODAL';
export const HIDE_DATA_IMPORT_PROCESS_MODAL = 'data-import/HIDE_DATA_IMPORT_PROCESS_MODAL';

export const SHOW_DATA_IMPORT_EXPORT_MODAL = 'data-import/SHOW_DATA_IMPORT_EXPORT_MODAL';
export const HIDE_DATA_IMPORT_EXPORT_MODAL = 'data-import/HIDE_DATA_IMPORT_EXPORT_MODAL';

export const GET_DATA_IMPORT = 'data-import/GET_IMPORT_DATA';
export const SET_DATA_IMPORT = 'data-import/SET_IMPORT_DATA';

export const GET_DRIVER_ATTRIBUTE_NAME = 'data-import/GET_DRIVER_ATTRIBUTE_NAME';
export const SET_DRIVER_ATTRIBUTE_NAME = 'data-import/SET_DRIVER_ATTRIBUTE_NAME';

export const DATA_IMPORT_SAVE_MAP_FILE = 'data-import/DATA_IMPORT_SAVE_MAP_FILE';
export const DATA_IMPORT_SAVE_MAP_FILE_COMPLETE = 'data-import/DATA_IMPORT_SAVE_MAP_FILE_COMPLETE';
export const DATA_IMPORT_UPLOAD_FILE = 'data-import/DATA_IMPORT_UPLOAD_FILE';
export const RESET_DATA_IMPORT_MAPPING_DATA = 'data-import/RESET_DATA_IMPORT_MAPPING_DATA';
export const EXPORT_DATA_IMPORT = 'data-import/EXPORT_DATA_IMPORT';
export const GET_MAPPED_LIST = 'data-import/GET_MAPPED_LIST';
export const DELETE_MAPPED_LIST = 'data-import/DELETE_MAPPED_LIST';
export const EDIT_MAPPED_LIST = 'data-import/EDIT_MAPPED_LIST';
export const SET_MAPPED_LIST = 'data-import/SET_MAPPED_LIST';
export const GET_CONFIRM_LIST = 'data-import/GET_CONFIRM_LIST';
export const SET_CONFIRM_LIST = 'data-import/SET_CONFIRM_LIST';
export const SET_FILE_INFORMATION = 'data-import/SET_FILE_INFORMATION';
export const SET_PROCESS_RESPONSE_DATA = 'data-import/SET_PROCESS_RESPONSE_DATA';

export const setProcessResponseData = (data: SuccessProcessResponse) => {
  return {
    type: SET_PROCESS_RESPONSE_DATA,
    payload: data,
  };
};
export const setFileInformation = (data: FileInformation) => {
  return {
    type: SET_FILE_INFORMATION,
    payload: data,
  };
};

export const showDataImportModal = () => {
  return {
    type: SHOW_DATA_IMPORT_MODAL,
  };
};
export const hideDataImportModal = () => {
  return {
    type: HIDE_DATA_IMPORT_MODAL,
  };
};

export const showDataImportProcessModal = () => {
  return {
    type: SHOW_DATA_IMPORT_PROCESS_MODAL,
  };
};
export const hideDataImportProcessModal = () => {
  return {
    type: HIDE_DATA_IMPORT_PROCESS_MODAL,
  };
};

export const showDataImportExportModal = () => {
  return {
    type: SHOW_DATA_IMPORT_EXPORT_MODAL,
  };
};
export const hideDataImportExportModal = () => {
  return {
    type: HIDE_DATA_IMPORT_EXPORT_MODAL,
  };
};

export const getDataImport = (data: any) => {
  return {
    type: GET_DATA_IMPORT,
    payload: data,
  };
};
export const setDataImport = (data: any) => {
  return {
    type: SET_DATA_IMPORT,
    payload: data,
  };
};
/*  Get Driver Attribute Name */
export const getDriverAttributeName = () => {
  return {
    type: GET_DRIVER_ATTRIBUTE_NAME,
  };
};
export const setDriverAttributeName = (data: any) => {
  return {
    type: SET_DRIVER_ATTRIBUTE_NAME,
    payload: data,
  };
};

export const dataImportSaveMappedFile = (data: any) => {
  return {
    type: DATA_IMPORT_SAVE_MAP_FILE,
    payload: data,
  };
};

export const setDataImportSaveMappedFileComplete = (data: any) => {
  return {
    type: DATA_IMPORT_SAVE_MAP_FILE_COMPLETE,
    payload: data,
  };
};

export const dataImportUploadFile = (data: any) => {
  return {
    type: DATA_IMPORT_UPLOAD_FILE,
    payload: data,
  };
};
export const resetDataImportMappingData = () => {
  return {
    type: RESET_DATA_IMPORT_MAPPING_DATA,
  };
};
export const exportDataImport = (data: any) => {
  return {
    type: EXPORT_DATA_IMPORT,
    payload: data,
  };
};

export const getMappedList = () => {
  return {
    type: GET_MAPPED_LIST,
  };
};
export const deleteMappedList = (data: any) => {
  return {
    type: DELETE_MAPPED_LIST,
    payload: data,
  };
};
export const editMappedList = (data: any) => {
  return {
    type: EDIT_MAPPED_LIST,
    payload: data,
  };
};
export const setMappedList = (data: any) => {
  return {
    type: SET_MAPPED_LIST,
    payload: data,
  };
};

export interface ShowDataImportModalAction extends Action<typeof SHOW_DATA_IMPORT_MODAL> {}
export interface HideDataImportModalAction extends Action<typeof HIDE_DATA_IMPORT_MODAL> {}

export interface ShowDataImportProcessModalAction extends Action<typeof SHOW_DATA_IMPORT_PROCESS_MODAL> {}
export interface HideDataImportProcessModalAction extends Action<typeof HIDE_DATA_IMPORT_PROCESS_MODAL> {}

export interface ShowDataImportExportModalAction extends Action<typeof SHOW_DATA_IMPORT_EXPORT_MODAL> {}
export interface HideDataImportExportModalAction extends Action<typeof HIDE_DATA_IMPORT_EXPORT_MODAL> {}

export interface SetDataImportAction extends Action<typeof SET_DATA_IMPORT> {
  payload: any;
}
export interface SetDriverAttributeNameAction extends Action<typeof SET_DRIVER_ATTRIBUTE_NAME> {
  payload: any;
}
export interface SetDataImportSaveMappedFileCompleteAction extends Action<typeof DATA_IMPORT_SAVE_MAP_FILE_COMPLETE> {
  payload: any;
}
export interface ResetDataImportMappingDataAction extends Action<typeof RESET_DATA_IMPORT_MAPPING_DATA> {}

export interface SetMappedListAction extends Action<typeof SET_MAPPED_LIST> {
  readonly payload: any;
}

export interface SetConfirmListAction extends Action<typeof SET_CONFIRM_LIST> {
  readonly payload: any;
}
export interface SetFileInformationAction extends Action<typeof SET_FILE_INFORMATION> {
  readonly payload: FileInformation;
}
export interface SetProcessResponseDataAction extends Action<typeof SET_PROCESS_RESPONSE_DATA> {
  readonly payload: SuccessProcessResponse;
}

export type DataImportAction =
  | ShowDataImportModalAction
  | HideDataImportModalAction
  | ShowDataImportProcessModalAction
  | HideDataImportProcessModalAction
  | ShowDataImportExportModalAction
  | HideDataImportExportModalAction
  | SetDataImportAction
  | SetDataImportSaveMappedFileCompleteAction
  | ResetDataImportMappingDataAction
  | SetMappedListAction
  | SetDriverAttributeNameAction
  | SetConfirmListAction
  | SetFileInformationAction
  | SetProcessResponseDataAction;
